import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import 'rxjs/add/operator/do'
import { Observable } from 'rxjs/Observable'
import exportLayer from './exportLayerDuck'
import { getViewparams } from '../selectors/viewparamsSelector'
import convertBoundsToMercatorBoundingBox from '../utility/convertBoundsToMercatorBoundingBox'

const formats = {
  'GEOTIFF': 'image/geotiff',
  'GEOJSON': 'application/geojson'
}

const createBoundingBoxString = (bounds) => {  
  const string = `${bounds._sw.lng},${bounds._sw.lat},${bounds._ne.lng},${bounds._ne.lat}`

  return string
}

const defaultSize = 512 * 4
const createUrl = ({ bounds, exportId, timeIso, encoding, idToken }) => {
  const boundingBoxString = createBoundingBoxString(bounds)
  const url = `http://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&version=1.1.0&request=GetMap&layers=coresight2:${exportId}&styles=&bbox=${boundingBoxString}&srs=EPSG:4326&format=${encodeURIComponent(encoding)}&TIME=${encodeURIComponent(timeIso)}&width=${defaultSize}&height=${defaultSize}&token=${idToken}`
  console.log(url)
  return url
}

const createGeojsonUrl = ({ timeIso }) => {
  const url = `https://s3-us-west-2.amazonaws.com/coresight-layers/ice-drift/${encodeURIComponent(timeIso)}/geojson.geojson`

  return url
}

const exportLayerEpic = (action$, store) =>
      action$
      .ofType(exportLayer.actions.exportLayerRequest().type)
      .mergeMap((action) => {
        const { format } = action.payload
        const encoding = formats[format]
        const state = store.getState()
        const {
          login: { authenticated, idToken },
          map: { bounds, toggleCenter }
        } = state
        const { exportId, datetimeId } = action.payload
        const time = state.layer.times[datetimeId]
        const timeIso = time ? new Date(time).toISOString() : ''
        const viewparams = getViewparams(state)
        const boundingBox = convertBoundsToMercatorBoundingBox(bounds)
        const url = format === 'GEOJSON'
              ? createGeojsonUrl({ timeIso })
              : createUrl({ bounds, exportId, timeIso, encoding, idToken })
        window.open(url)
        const response = fetch(`https://feathers.looknorthservices.com`)
        const observable = Observable.from(response)

        return observable
      })
      .map((payload) => exportLayer.actions.exportLayerSuccess(payload))

export default exportLayerEpic



// WEBPACK FOOTER //
// ./src/redux/exportLayerEpic.js